var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTutorial && _vm.content)?_c('div',{attrs:{"id":"worksends-right-sidebar"}},[_c('div',{attrs:{"id":"worksends-help"},domProps:{"innerHTML":_vm._s(_vm.content)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }